<div class="login_page ng-scope">
  <div class="login-wrapper ng-scope">
    <div id="login" style="padding: 15px 30px 15px 30px;"
      class="login loginpage col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-3 col-sm-6 col-xs-offset-2 col-xs-8">

     
      <h1 style="display: flex; align-items: center; gap: 10px;">
         <!-- <a href="javascript:;" title="Login Page" tabindex="-1">Fous Tele Ophthalmology - Account Management</a> -->
        <img src="../../assets/images/forus-logo.png" alt="Forus Logo" style="max-width: 100%; height: auto; width: 100%;">
      </h1>

      <div *ngIf="!showOtpForm">
        <form autocomplete="off" name="form" class="form
        -validation" novalidate (ngSubmit)="loginSubmit()"
          #loginForm="ngForm">
          <div class="text-danger text-center message">
            Sign in to continue.
          </div>
          <div class="mTop15">
            <input type="email" autofocus name="email" id="user_email"
              pattern="^[\w+]+([.-]?[\w+]+)*@\w+([.-]?\w+)*(\.\w{2,3})+$" #email="ngModel"
              [(ngModel)]="credential.email" class="input" placeholder="Email" required autocomplete="off" />
            <div *ngIf="email.errors && email.dirty" class="danger-text">
              <div *ngIf="email.errors.required">
                Email is required
              </div>
              <div *ngIf="email.errors.pattern">
                Enter valid email address.
              </div>
            </div>
          </div>
          <div class="mTop15">
            <input type="password" [(ngModel)]="credential.password" #password="ngModel" name="pwd" id="user_password"
              class="input" placeholder="Password" required autocomplete="off" />
            <div [hidden]="password.valid || password.pristine" class="danger-text">
              Password is required
            </div>
          </div>
          <!-- <p class="forgetmenot" class="mTop10">
            <label class="icheck icheck-white" for="rememberme">
              <input type="checkbox" value="forever" name="rememberme" id="rememberme">
              <i></i> Remember me
            </label>
          </p> -->
          <div style="font-size: 13px;">Forus Health uses cookies and active components to track visitor's preferences
            and customize the design of the websites.
            To view the the data privacy policy <a href="https://forushealth.com/privacy-policy.html" target="_blank"
              style="font-size: 13px;color: dodgerblue;">click here</a>
          </div>
          <div class="controls">
            <div class="chiller_cb">
              <div class="chiller_cb">
                <input id="isPolicyAgreed" [(ngModel)]="isPolicyAgreed" name="isPolicyAgreed" type="checkbox" />
                <label style="font-weight: normal;font-size: 13px;text-transform: none;" for="isPolicyAgreed">Accept the
                  data privacy policy</label>
                <span></span>
              </div>
            </div>
          </div>
          <div class="submit">
            <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-token">
            <div id="g-recaptcha-token-v2" class="g-recaptcha"
              style="width: 100%;align-items: center;justify-content: center;"></div>
            <button *ngIf="!manualCaptcha" [disabled]="!loginForm.form.valid || !isPolicyAgreed" type="submit"
              class="btn btn-accent btn-block  btn-primary">Sign In
            </button>
          </div>
        </form>
        <div class="forgot-password">
          <p id="nav">
            <a title="Reset your password" href="javascript:;" [routerLink]="['/recoverpwd']">Forgot password?</a>
          </p>
        </div>
      </div>
      <div *ngIf="showOtpForm">
        <div class="text-danger text-center message">
          Enter 4 digit OTP.
        </div>
        <div class="col-xs-3"><input type="text" class="form-control" [(ngModel)]="otpkey1" id="otpkey1" maxlength="1"
            (keyup)="optKeyFocus()"
            onkeydown="javascript: return (event.keyCode<=57 && event.keyCode >= 48) || event.keyCode==8 || event.keyCode==9? true : false">
        </div>
        <div class="col-xs-3"><input type="text" class="form-control" [(ngModel)]="otpkey2" id="otpkey2" maxlength="1"
            (keyup)="optKeyFocus()"
            onkeydown="javascript: return (event.keyCode<=57 && event.keyCode >= 48) || event.keyCode==8 || event.keyCode==9? true : false">
        </div>
        <div class="col-xs-3"><input type="text" class="form-control" [(ngModel)]="otpkey3" id="otpkey3" maxlength="1"
            (keyup)="optKeyFocus()"
            onkeydown="javascript: return (event.keyCode<=57 && event.keyCode >= 48) || event.keyCode==8 || event.keyCode==9? true : false">
        </div>
        <div class="col-xs-3"><input type="text" class="form-control" [(ngModel)]="otpkey4" id="otpkey4" maxlength="1"
            (keyup)="optKeyFocus()"
            onkeydown="javascript: return (event.keyCode<=57 && event.keyCode >= 48) || event.keyCode==8 || event.keyCode==9? true : false">
        </div>
        <div class="col-xs-12" style="margin-top: 20px !important;">
          <p class="text-center">Your OTP will expire in {{(timeRemainingMinutes <
              10)?'0'+timeRemainingMinutes:timeRemainingMinutes}}:{{(timeRemainingSeconds <
              10)?'0'+timeRemainingSeconds:timeRemainingSeconds}}</p>
              <p class="text-center" style="cursor:pointer;color: cornflowerblue;font-size: 14px;"
                (click)="resendOTP()">Resend OTP</p>
        </div>
        <div>
          <button class="btn btn-block btn-primary mt-lg" (click)="submitOTP()"
            [disabled]="otpkey1.length!=1 || otpkey2.length!=1 || otpkey3.length!=1 || otpkey4.length!=1">Sign
            In</button>
        </div>
      </div>
    </div>
    <div class="col-lg-offset-4 col-lg-4 col-md-offset-4 col-md-6 col-sm-offset-4 col-sm-6 col-xs-offset-2 col-xs-8"
      style="text-align: center;
    margin-top: 10px;
    color: #5c5c5c;">
      <span>&copy;2018 -</span>
      <span style="margin-left: 3px;">{{year}}</span>
      <span> Forus Health Digital Health Platform - {{appVersion}}</span>
      <br>
      <span style="margin-top: 3px;color: rgb(73, 73, 198);"> Information Security Compliance Certifications
        ISO 27001:2022, ISO 27018:2019, ISO 27017:2015, HIPAA compliant.</span>
    </div>
  </div>
</div>